import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  visitId: string().required(),
  noteId: string().required(),
  note: object(),
})

export const url = ({ visitId, noteId }) => `/v1/visits/${visitId}/notes/${noteId}`

export const getBody = ({ note }) => ({ ...note })
